import { Injectable } from '@angular/core';
import { map } from 'rxjs';

import {
  Ticket,
  TicketRecordType,
  TicketStatus,
} from 'src/app/models/ticket/ticket.model';
import { getTicketType } from 'src/app/models/ticket/ticket.util';
import {
  LoadTickets,
  LoadTicketsFail,
  LoadTicketsSuccess,
} from '../../../store';
import { ChartService } from './chart.service';
import { SingleValueKPI } from '../../types';
import { ChartType } from '../../types/chart-type';

@Injectable()
export class OpenMaintenanceCasesChartService extends ChartService<SingleValueKPI> {
  public readonly chart$ = this.chartsDataLoader({
    request: LoadTickets,
    failure: LoadTicketsFail,
    success: LoadTicketsSuccess,
  }).pipe(
    map(({ loading, data }) => {
      const dataValue: number =
        data?.data?.filter((ticket) => this.filterByStatusAndType(ticket))
          .length || 0;

      return {
        ngClass: [],
        loading,
        data: {
          type: ChartType.SINGLE,
          id: 'Open/Scheduled maintenance cases',
          title: 'Open Scheduled Maintenance Tickets',
          value: dataValue,
          hyperlink: '/tickets',
          linkParams: {
            groupBy: 'Status',
            status: TicketStatus.Open,
            type: TicketRecordType.Maintenance,
          },
          linkEnabled: true,
        } satisfies SingleValueKPI,
      };
    }),
  );

  private filterByStatusAndType(ticket: Ticket): boolean {
    return (
      getTicketType(ticket).includes(TicketRecordType.Maintenance) &&
      !ticket.IsClosed
    );
  }
}
